import { post } from 'axios'
import Vue from 'vue'
import { normalizeFakeEmail } from '@/helpers/mailFake'

function initialState() {
  return {
    email: undefined,
    password: undefined,
    message: undefined,
  }
}

function formatToAuth(data) {
  return {
    password: state.password,
    email: normalizeFakeEmail(data.email.replace(' ', '+')),
    googleRecaptcha: data.googleRecaptcha,
    token: data.token,
  }
}

const state = initialState()

const getters = {
  password: state => state,
}
const actions = {
  sendPassword({ state }) {
    return post('/reset-password', { email: state.email }).then(response => {
      return response.data.token
    })
  },

  resetPassword({ state }, data) {
    return Vue.axios
      .put('/reset-password', {
        token: data.token,
        password: state.password,
      })
      .then(() =>
        post('/auth/login', formatToAuth(data)).then(r => r.data.token)
      )
  },
}

// mutations
const mutations = {
  updateEmail(state, email) {
    state.email = email
  },
  updatePassword(state, password) {
    state.password = password
  },
  updateMessage(state, message) {
    state.message = message
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
